import axios from "axios";
import React, { useEffect, useState } from "react";
import { APIURL } from "../../../Config";
import EmployerProfile from "../../EmployerProfile";
import Pagination from "../../Pagination/Pagination";
import RegisterEmployerDetails from "../../RegisterEmployerDetails";
import { DownloadTableExcel } from "react-export-table-to-excel";
import OutStandingDetails from "../../OutStandingDetails";

function RegisteredCorporates() {
  const token = localStorage.getItem("token");

  const [isLoader, setIsLoader] = useState(false);
  const [month, setMonth] = useState(0);
  const [emailid, setEmailid] = useState();
  const [cid, setCid] = useState();
  const [months, setMonths] = useState([]);
  const [empname, setEmpname] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [showSearchName, setShowSearchName] = useState(false);
  const [outStanding, setOutStanding] = useState(false);
  const [rejectedReason, setRejectedReason] = useState(false);
  const [data, setData] = useState([]);
  const [showPrePage, setShowPrePage] = useState(100);
  const tableRegisteredCorporate = React.useRef(null);

  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const [activeTab, setActiveTab] = useState("profile");
  const [activeTab2, setActiveTab2] = useState("employerDetails");
  const [apiKey, setApiKey] = useState("alldata");

  useEffect(() => {
    if (outStanding && activeTab2 === "outStandingDetails") {
      setActiveTab2("outStandingDetails");
    } else {
      setActiveTab2("employerDetails");
    }
  }, [outStanding]);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const getMonthName = (date) =>
    date.toLocaleString("default", { month: "long" });

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();

    const monthsArray = [];
    for (let i = 0; i < 3; i++) {
      const monthDate = new Date(currentYear, now.getMonth() - i, 1);
      const monthName = getMonthName(monthDate);
      monthsArray.push({
        name: `${monthName} ${currentYear}`,
        value: i.toString(),
      });
    }

    setMonths(monthsArray);
    setMonth("0");
  }, []);

  useEffect(() => {
    getRegisteredEmployer();
  }, []);

  const getRegisteredEmployer = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/registeredemployer`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("response", response);
        setData(response?.data);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item"
              id="registered-corporates-tab"
              data-bs-toggle="tab"
              data-bs-target="#registered-corporates"
              type="button"
              role="tab"
              aria-controls="registered-corporates"
              aria-selected="true"
            >
              Registered Employer
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="registered-corporates"
            role="tabpanel"
            aria-labelledby="registered-corporates-tab"
          >
            {showSearch ? (
              <div>
                {!showSearchName ? (
                  <>
                    <ul
                      className="nav nav-tabs d-flex justify-content-between align-items-center"
                      id="myTabs"
                      role="tablist"
                    >
                      <div className="d-flex">
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              activeTab === "profile" ? "active" : ""
                            }`}
                            onClick={() => setActiveTab("profile")}
                          >
                            Profile
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              activeTab === "employerDetails" ? "active" : ""
                            }`}
                            onClick={() => setActiveTab("employerDetails")}
                          >
                            Employee Details
                          </button>
                        </li>
                      </div>
                      <li className="nav-item ml-auto" role="presentation">
                        <button
                          className="btn btn-secondary"
                          style={{ width: "100px" }}
                          onClick={() => setShowSearch(false)}
                        >
                          Back
                        </button>
                      </li>
                    </ul>
                    <div className="tab-content mt-3">
                      {activeTab === "employerDetails" && (
                        <div className="tab-pane fade show active">
                          <RegisterEmployerDetails
                            emailid={emailid}
                            rejectedReason={false}
                            apiKey={apiKey}
                          />
                        </div>
                      )}
                      {activeTab === "profile" && (
                        <div className="tab-pane fade show active">
                          <EmployerProfile emailid={emailid} />
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <ul
                      className="nav nav-tabs d-flex justify-content-between align-items-center"
                      id="myTabs"
                      role="tablist"
                    >
                      {apiKey == "alldata" && (
                        <div className="d-flex">
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${
                                activeTab2 === "employerDetails" ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab2("employerDetails");
                                setApiKey("alldata");
                              }}
                            >
                              ALL
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${
                                activeTab2 === "use" ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab2("use");
                                setApiKey("usedlimit");
                              }}
                            >
                              Use Limit
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${
                                activeTab2 === "unuse" ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab2("unuse");
                                setApiKey("unusedlimit");
                              }}
                            >
                              Un-use Limit
                            </button>
                          </li>
                          {/* {outStanding && (
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${
                                activeTab2 === "outStandingDetails"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() =>
                                setActiveTab2("outStandingDetails")
                              }
                            >
                              OutStanding
                            </button>
                          </li>
                        )} */}
                        </div>
                      )}
                      <li className="nav-item ml-auto" role="presentation">
                        <button
                          className="btn btn-secondary"
                          style={{ width: "100px" }}
                          onClick={() => setShowSearch(false)}
                        >
                          Back
                        </button>
                      </li>
                    </ul>
                    <div className="tab-content mt-3">
                      {activeTab2 === "employerDetails" && (
                        <div className="tab-pane fade show active">
                          <RegisterEmployerDetails
                            emailid={emailid}
                            rejectedReason={rejectedReason}
                            cid={cid}
                            apiKey={apiKey}
                            activeTab2={activeTab2}
                          />
                        </div>
                      )}
                      {activeTab2 === "use" && (
                        <div className="tab-pane fade show active">
                          <RegisterEmployerDetails
                            emailid={emailid}
                            rejectedReason={rejectedReason}
                            apiKey={apiKey}
                            cid={cid}
                            activeTab2={activeTab2}
                          />
                        </div>
                      )}
                      {activeTab2 === "unuse" && (
                        <div className="tab-pane fade show active">
                          <RegisterEmployerDetails
                            emailid={emailid}
                            rejectedReason={rejectedReason}
                            apiKey={apiKey}
                            cid={cid}
                            activeTab2={activeTab2}
                          />
                        </div>
                      )}
                      {/* {outStanding && activeTab2 === "outStandingDetails" && (
                        <div className="tab-pane fade show active">
                          <div>
                            <OutStandingDetails emailid={emailid} />
                          </div>
                        </div>
                      )} */}
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="pt-3">
                <div className="card">
                  <DownloadTableExcel
                    filename="RegisteredCorporate"
                    sheet="users"
                    currentTableRef={tableRegisteredCorporate.current}
                  >
                    <button
                      className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                      style={{
                        width: "120px",
                        backgroundColor: "#66a725",
                      }}
                    >
                      Download
                    </button>
                  </DownloadTableExcel>
                  <div className="p-3 pt-0">
                    <div className="mx-md-3 d-flex flex-row flex-md-row align-items-center justify-content-end"></div>

                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive mt-3">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              <th style={{ textAlign: "center" }}>
                                Employer name
                              </th>
                              <th style={{ textAlign: "center" }}>Category</th>
                              <th style={{ textAlign: "center" }}>
                                No. of Employees uploaded
                              </th>
                              <th style={{ textAlign: "center" }}>
                                No. of Employees Rejected
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Limit Assigned amt (by ST)
                              </th>

                              <th style={{ textAlign: "center" }}>
                                Limit Utilized
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Utilization %{" "}
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Unpaid count
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Unpaid amt
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td
                                  style={{ color: "blue", cursor: "pointer" }}
                                  onClick={() => {
                                    if (item.empname) {
                                      setEmpname(item.empname);
                                      setShowSearch(true);
                                      setEmailid(item.emailid);
                                      setShowSearchName(false);
                                      setApiKey("alldata");
                                      setCid(item.id);
                                    }
                                  }}
                                >
                                  {item.empname}
                                </td>
                                <td>
                                  {item?.model === "Assured"
                                    ? ` ${item?.model}/${item?.code}`
                                    : item?.model}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    setShowSearch(true);
                                    setEmailid(item.emailid);
                                    setShowSearchName(true);
                                    setRejectedReason(false);
                                    setApiKey("alldata");
                                    setCid(item.id);
                                  }}
                                >
                                  {item.uploaded}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    setShowSearch(true);
                                    setEmailid(item.emailid);
                                    setShowSearchName(true);

                                    setRejectedReason(true);
                                    setApiKey("rejected");
                                  }}
                                >
                                  {item.rejected}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.limitassigned}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    setShowSearch(true);
                                    setEmailid(item.emailid);
                                    setShowSearchName(true);
                                    setRejectedReason(false);

                                    setApiKey("limitutilized");
                                  }}
                                >
                                  {item.limitused}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.utilization}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.unpaid_count}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.unpaid_amount.toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {data && data.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={data.length}
                      />
                    )}
                    <table
                      className="table table-striped mt-3 "
                      style={{ display: "none" }}
                      ref={tableRegisteredCorporate}
                    >
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th style={{ textAlign: "center" }}>Employer name</th>
                          <th style={{ textAlign: "center" }}>Category</th>
                          <th style={{ textAlign: "center" }}>
                            No. of Employees uploaded
                          </th>
                          <th style={{ textAlign: "center" }}>
                            No. of Employees Rejected
                          </th>
                          <th style={{ textAlign: "center" }}>
                            Limit Assigned amt (by ST)
                          </th>

                          <th style={{ textAlign: "center" }}>
                            Limit Utilized
                          </th>
                          <th style={{ textAlign: "center" }}>
                            Utilization %{" "}
                          </th>
                          <th style={{ textAlign: "center" }}>Unpaid count</th>
                          <th style={{ textAlign: "center" }}>Unpaid amt</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td
                              style={{ color: "blue", cursor: "pointer" }}
                              onClick={() => {
                                if (item.empname) {
                                  setEmpname(item.empname);
                                  setShowSearch(true);
                                  setEmailid(item.emailid);
                                  setShowSearchName(false);
                                  setApiKey("alldata");
                                  setCid(item.id);
                                }
                              }}
                            >
                              {item.empname}
                            </td>
                            <td>
                              {item?.model === "Assured"
                                ? ` ${item?.model}/${item?.code}`
                                : item?.model}
                            </td>
                            <td
                              style={{
                                color: "blue",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                              onClick={() => {
                                setShowSearch(true);
                                setEmailid(item.emailid);
                                setCid(item.id);
                                setShowSearchName(true);
                                setRejectedReason(false);
                                setApiKey("alldata");
                              }}
                            >
                              {item.uploaded}
                            </td>
                            <td
                              style={{
                                color: "blue",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                              onClick={() => {
                                setShowSearch(true);
                                setEmailid(item.emailid);
                                setShowSearchName(true);
                                setRejectedReason(true);
                                setApiKey("rejected");
                              }}
                            >
                              {item.rejected}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.limitassigned}
                            </td>
                            <td
                              style={{
                                color: "blue",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                              onClick={() => {
                                setShowSearch(true);
                                setEmailid(item.emailid);
                                setShowSearchName(true);
                                setRejectedReason(false);
                                setApiKey("limitutilized");
                              }}
                            >
                              {item.limitused}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.utilization}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.unpaid_count}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.unpaid_amount}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisteredCorporates;
